import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeScreen.css';
import GetCompanyData from './API/GetCompanyData';
import GetCompanyPrice from './API/GetCompanyPrice';
import GetPriceHistory from './API/GetPriceHistory';
import GetCompanyNews from './API/GetCompanyNews';

function HomeScreen() {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (event) => {
    setInputValue(event.target.value.toUpperCase());
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const companyData = await GetCompanyData(inputValue);
    const companyPrice = await GetCompanyPrice(inputValue);
    const priceHistory = await GetPriceHistory(inputValue);
    const companyNews = await GetCompanyNews(inputValue);

    console.log(companyNews);

    if (
      companyData['Name'] &&
      companyPrice['05. price'] &&
      priceHistory['Time Series (Daily)']
    ) {
      navigate(`/stock/${inputValue}`, {
        state: {
          companyData: companyData,
          companyPrice: companyPrice,
          priceHistory: priceHistory,
          companyNews: companyNews,
        },
      });
    }
  };

  return (
    <div className="home-screen">
      <h1 className="title">StockTrackerV2</h1>
      <form onSubmit={handleFormSubmit}>
        <div className="input-container">
          <input
            type="text"
            placeholder="Enter stock symbol (AAPL etc)"
            className="input-box"
            value={inputValue}
            onChange={handleInputChange}
          />
          <button type="submit" className="submit-button">
            Search
          </button>
        </div>
      </form>
      <div className="home-disclaimer">
        If nothing loads after clicking search the free API provider may have
        rate limited the connection. In this case please wait a minute and
        retry!
      </div>
    </div>
  );
}

export default HomeScreen;
